import { useContext } from "react";
import { DashboardDialogsContext } from "../context/dashboardDialogsContext";

export const useDashboardDialogs = () => {
  const context = useContext(DashboardDialogsContext);
  if (!context) {
    throw new Error("useDashboardDialogs must be used within a DashboardDialogsProvider");
  }
  return context;
};
